import Api from '../../../../api/configuration'
import generateStaticProps from '../../../../api/configuration/helper/generate-static-props'
import Home from '../../../../app/course/home'

export default Home

export async function getStaticPaths() {
  const coursePaths = await Api.corePublic
    .get(`home/landing`) // todo: req a dedicated api for this
    .then(({ result: { recordedCourses: courses = [] } }) =>
      courses.map(({ teacherLivdemyId, info: { courseUrl } }) => ({
        params: { livdemyId: teacherLivdemyId, url: courseUrl },
      })),
    )
    .catch(() => [])

  return {
    fallback: 'blocking',
    paths: process.env.VERCEL_GIT_COMMIT_REF === 'main' ? coursePaths : [],
  }
}

export async function getStaticProps({ params: { livdemyId, url } }) {
  return generateStaticProps(`course/${livdemyId}/${url}`, undefined, {
    server: 'public-cache',
  })
}
